<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box0">
      <!-- 轮播图 -->
      <el-carousel height="823px" indicator-position="none" arrow="never">
        <el-carousel-item>
          <img style="width: 100%; height: 100%"
            v-if="detailsList.pic && detailsList.pic[0]"
            :src="detailsList.pic[0]" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 标题 -->
    <div class="title">
      <span>{{ detailsList.name }}</span>
      <!-- <img src="../../assets/collection1.png" v-if="isCategory == 0"
        @click="getCategory" />
      <img src="../../assets/collection2.png" v-if="isCategory == 1"
        @click="getCategory" /> -->
    </div>
    <div class="box">
      <!-- 简介 -->
      <div class="introduction">
        <div class="item item1">
          <p class="item-title">
            <span></span>
            <span v-if="detailsList.name">{{ detailsList.name }}</span>
            <span v-if="detailsList.workStatus == 0"
              style="color: #00fff0">Free</span>
            <span v-if="detailsList.workStatus == 1"
              style="color: #10b962">Rest</span>
            <span v-if="detailsList.workStatus == 2" style="color: #ff511b">At
              work</span>
          </p>
          <div class="test" style="
              overflow: hidden;
              max-height: 244px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <p class="bg"></p>
            <ul>
              <li>
                <span>Price</span>
                <span>${{ parseInt(detailsList.price) }}</span>
              </li>
              <li>
                <span>Order number</span>
                <span>{{ detailsList.counts || 0 }}</span>
              </li>
              <li>
                <span>Service area</span>
                <span>{{ detailsList.workArea }}</span>
              </li>
              <li>
                <span>Areas of expertise</span>
                <span>{{ detailsList.beGoodAt }}</span>
              </li>
              <li>
                <span>Entire period of actual operation</span>
                <span>{{ detailsList.workYear }}Year</span>
              </li>
              <li>
                <span>Type</span>
                <span v-if="detailsList.serveType == 0">Pre-loading /
                  Discharging Survey</span>
                <span v-if="detailsList.serveType == 1">On/Off Hire Bunker
                  Survey/Bunker & Condition Survey</span>
                <span v-if="detailsList.serveType == 2">Bunkering Survey</span>
                <span v-if="detailsList.serveType == 3">Draft Survey</span>
                <span v-if="detailsList.serveType == 4">Insurance Adjust
                  Survey</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="item item2">
          <p class="item-title">
            <span></span>
            <span>Curriculum vitae</span>
            <span></span>
          </p>
          <p class="bg"></p>
          <div class="test" style="
              overflow: hidden;
              max-height: 244px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <li>{{ detailsList.resume }}</li>
          </div>
        </div>
        <div class="item item3">
          <p class="item-title">
            <span></span>
            <span>Working experience</span>
            <span></span>
          </p>
          <p class="bg"></p>
          <div class="test" style="
              overflow: hidden;
              max-height: 204px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <li>{{ detailsList.experience }}</li>
          </div>
        </div>
        <div class="item item4">
          <p class="item-title">
            <span>。。。。</span>
            <span>His score</span>
            <span style="color: #00fff0" v-if="detailsList.score">{{
              detailsList.score
            }}</span>
            <span style="color: #00fff0; font-size: 18px" v-else>暂无评价</span>
          </p>
          <p class="bg"></p>
          <div class="test" style="
              overflow: hidden;
              max-height: 204px;
              overflow-y: auto;
              margin-top: 20px;
            ">
            <div class="li">
              <div class="li-title" v-if="commentList.length == 0">
                暂无评价
              </div>
              <el-carousel height="236px" :autoplay="false"
                indicator-position="none" arrow="always" v-else>
                <el-carousel-item v-for="(v, k) in commentList" :key="k">
                  <div class="li-item">
                    <div class="li-item-left">
                      <div class="div1"><img :src="v.userIcon" /></div>
                      <div class="div2">
                        <p class="up">
                          <span>{{ v.serveTitle }}</span>
                          <el-rate v-model="v.score" disabled
                            :colors="['#00FFF0', '#00FFF0', '#00FFF0']"
                            disabled-void-color="#33888E"></el-rate>
                        </p>
                        <p class="down">{{ v.content }}</p>
                      </div>
                    </div>
                    <div class="li-item-right">{{ v.createDate }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务案例 -->
      <div class="case" v-if="detailsList.atDocCaseList">
        <p class="case-title">Service case</p>
        <div class="case-content">
          <div class="case-item"
            v-for="(item, index) in detailsList.atDocCaseList" :key="index"
            @click="goCaseDetails(item)">
            <p class="case-item-top">{{ item.title }}</p>
            <div class="case-item-bottom">
              <div class="case-item-bottom-left">
                <img style="object-fit: cover;" v-if="item.icon"
                  :src="item.icon.split('|')[0]" />
              </div>
              <div class="case-item-bottom-right">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 案例详情 -->
      <div class="introduce">
        <div class="nd-top">
          <div class="nd-top-title">Case introduction</div>
        </div>
        <div class="time">time：{{ detailsList.updateDate }}</div>
        <div class="address">address：{{ detailsList.address }}</div>
        <div class="name">name：{{ detailsList.name }}</div>
        <div class="introduceText">introduce：{{ detailsList.remarks }}</div>
      </div>
      <!-- 滚动图 -->
      <div class="scroll">
        <div class="nd-top" style="margin-bottom: 20px; padding-top: 10px">
          <div class="nd-top-title">Site photos</div>
        </div>
        <scrollBox v-if="detailsList.pic">
          <img class="scrollImage" :src="item" key="i"
            v-for="(item, i) in detailsList.pic" alt="" />
        </scrollBox>
      </div>
      <!-- 你可能需要 -->
      <!-- <div class="need">
        <div class="nd-top">
          <div class="nd-top-title">You may also need</div>
        </div>
        <div class="nd-bottom">
          <div class="nd-bottom-item" v-for="(item, index) in serveList"
            :key="index" @click="goDetails(item.serveId)">
            <div class="nd-bottom-item-top">{{ item.serveTitle }}</div>
            <div class="nd-bottom-item-bottom">
              <div class="nd-bottom-item-bottom-left"><img :src="item.pic" />
              </div>
              <div class="nd-bottom-item-bottom-right">
                <div class="nd-bottom-item-bottom-right-list">
                  <div class="nd-bottom-item-bottom-right-li">
                    Money：{{ item.price }}</div>
                  <div class="nd-bottom-item-bottom-right-li">
                    Score：{{ item.score || 0 }}</div>
                  <div class="nd-bottom-item-bottom-right-li">
                    Order quantity：{{ item.counts || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
import calendar from "../../components/calendar.vue";
import scrollBox from "@/components/scroll.vue";
export default {
  name: "detail",
  components: {
    navTop,
    navFooter,
    calendar,
    scrollBox,
  },
  data () {
    return {
      id: "", //服务id
      detailsList: {}, //服务数据
      commentList: [], //评论列表
      count: "", //评论总条数
      serveList: [], //您可能还需要
      isCategory: "", //是否收藏
      calendarList: [], //已选日期
    };
  },
  created () {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({ path: "/" });
    } else {
      this.id = this.$route.query.id;
      this.getDetail();
      this.getAppriselist();
      this.getIscategory();
    }
  },
  methods: {
    // 选择服务
    selectService (e) {
      this.service = e.target.value;
    },
    // 检验师详情
    getDetail () {
      // let data = {
      // 	serveId: this.id
      // };
      // this.$api.detail(data).then(res => {
      // 	console.log(res);
      // 	if (res.result == 0) {
      // 		this.detailsList = res.data;
      // 		this.getServe();
      // 	}
      // });
      let data = {
        id: this.id,
      };
      this.$api.alDetail(data).then((res) => {
        if (res.result == 0) {
          if (res.data.pic) {
            res.data.pic = res.data.pic.split("|");
          } else {
            res.data.pic = [];
          }
          this.detailsList = res.data;
          this.getServe();
        }
      });
    },
    // 是否收藏
    getIscategory () {
      let data = {
        uid: sessionStorage.getItem("uid"),
        serveId: this.id,
      };
      this.$api.iscategory(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.isCategory = res.data.isCategory;
        }
      });
    },
    // 收藏、取消收藏
    getCategory () {
      let data = {
        uid: sessionStorage.getItem("uid"),
        serveId: this.id,
      };
      this.$api.category(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.getIscategory();
          this.$message({
            message: "success",
            type: "success",
            center: true,
            duration: 1000,
          });
        }
      });
    },
    // 评价列表
    getAppriselist () {
      let data = {
        serveId: this.id,
        nowPage: 1,
        pageCount: 10000,
      };
      this.$api.appriselist(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.commentList = res.data.list;
          // this.count = Math.ceil(res.data.count / 4);
          // let arrLength = res.data.list.length;
          // let num = 4;
          // let index = 0;
          // for (let i = 0; i < arrLength; i++) {
          // 	if (i % num === 0 && i !== 0) {
          // 		this.commentList.push(res.data.list.slice(index, i));
          // 		index = i;
          // 	}
          // 	if (i + 1 === arrLength) {
          // 		this.commentList.push(res.data.list.slice(index, i + 1));
          // 	}
          // }
        }
      });
    },
    // 您可能还需要列表
    getServe () {
      let data = {
        type: 3,
        docId: this.detailsList.id,
        nowPage: 1,
        pageCount: 100000,
      };
      this.$api.serve(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.serveList = res.data.list;
        }
      });
    },
    // 您可能还需要跳转
    goDetails (id) {
      let { href } = this.$router.resolve({
        path: "/detail",
        query: { id: id },
      });
      window.open(href, "_blank");
    },

    // 案例详情
    goCaseDetails (item) {
      let { href } = this.$router.resolve({
        path: "/caseDetails",
        query: { item: JSON.stringify(item) },
      });
      console.log(href);
      window.open(href, "_blank");
    },
    // 接受选择日期
    fnVal (val) {
      this.calendarList = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background: #3E414A;
  .box0 {
    padding-top: 50px;
    box-sizing: border-box;
  }
  .box {
    // 简介
    .introduction {
      margin-top: 58px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      .item {
        margin-top: 40px;
        width: 695px;
        border-radius: 21px;
        background-image: url(../../assets/details-items.png);
        background-size: 100% 100%;
        .item-title {
          height: 70px;
          padding: 16px 35px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1) {
            display: inline-block;
            width: 86px;
          }
          span:nth-child(2) {
            font-size: 28px;
            color: #00fff0;
            line-height: 1em;
          }
          span:nth-child(3) {
            display: inline-block;
            width: 86px;
            font-size: 22px;
            color: #ff3f00;
            line-height: 1em;
            text-align: center;
          }
        }
      }
      .item1 {
        height: 418px;
        padding: 19px 40px 53px 44px;
        box-sizing: border-box;
        ul {
          padding: 20px 34px 0 36px;
          box-sizing: border-box;
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 9px;
            span:nth-child(1) {
              font-size: 26px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #e3fffd;
            }
            span:nth-child(2) {
              font-size: 26px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #00fff0;
            }
          }
        }
      }
      .item2 {
        height: 418px;
        padding: 19px 40px 12px 44px;
        box-sizing: border-box;
        li {
          padding: 34px 34px 0 36px;
          box-sizing: border-box;
          font-size: 26px;
          color: #e3fffd;
        }
      }
      .item3 {
        height: 362px;
        padding: 19px 40px 10px 44px;
        box-sizing: border-box;
        li {
          padding: 34px 34px 0 36px;
          box-sizing: border-box;
          font-size: 26px;
          color: #e3fffd;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
      }
      .item4 {
        height: 362px;
        background-size: 100% 100%;
        padding: 19px 40px 10px 44px;
        box-sizing: border-box;
        .li {
          padding: 17px 0 20px;
          box-sizing: border-box;
          .li-title {
            width: 100%;
            // height: 100%;
            font-size: 26px;
            color: #e3fffd;
            text-align: center;
            // line-height: 225px;
          }
          ::v-deep .el-carousel__arrow {
            background: #000;
            width: 0;
            // height: 0;
            i {
              color: #00fff1;
              font-size: 30px;
            }
          }
          ::v-deep .el-carousel__arrow--left {
            left: 0;
          }
          ::v-deep .el-carousel__arrow--right {
            right: 21px;
          }
          .li-item {
            width: 100%;
            height: 100%;
            margin-bottom: 12px;
            padding: 0 50px 0 36px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .li-item-left {
              display: flex;
              align-items: center;
              .div1 {
                img {
                  width: 100px;
                  height: 100px;
                  display: block;
                  border-radius: 50%;
                }
              }
              .div2 {
                margin-left: 10px;
                .up {
                  display: flex;
                  align-items: center;
                  span {
                    font-size: 18px;
                    font-weight: bold;
                    color: #88b1d0;
                    margin-right: 10px;
                  }
                  ::v-deep .el-rate__icon {
                    margin-right: 2px;
                    font-size: 20px;
                  }
                }
                .down {
                  width: 312px;
                  margin-top: 5px;
                  font-size: 14px;
                  font-weight: bold;
                  color: #00fff0;
                }
              }
            }
            .li-item-right {
              font-weight: bold;
              color: #27e0fb;
            }
          }
          .li-item:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    // 服务案例
    .case {
      width: 100%;
      border-radius: 45px;
      margin-top: 61px;
      background-image: url(../../assets/details-case.png);
      background-size: 100% 100%;
      padding: 0 87px 20px 114px;
      box-sizing: border-box;
      .case-title {
        padding-top: 30px;
        box-sizing: border-box;
        line-height: 1em;
        font-size: 72px;
        color: #00fff0;
        text-align: center;
      }
      .case-content {
        padding: 71px 65px 74px 72px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        .case-item {
          margin-right: 152px;
          margin-bottom: 29px;
          .case-item-top {
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #ffffff;
            line-height: 1em;
            margin-bottom: 5px;
            text-align: right;
            padding-right: 95px;
            padding-left: 238px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .case-item-bottom {
            display: flex;
            align-items: flex-start;
            .case-item-bottom-left {
              width: 220px;
              height: 131px;
              background-image: url(../../assets/index-hot-item.png);
              background-size: 100% 100%;
              padding: 15px 20px;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            .case-item-bottom-right {
              width: 338px;
              height: 174px;
              background-image: url(../../assets/details-case-item-right.png);
              background-size: 100% 100%;
              margin-left: -51px;
              color: #ffffff;
              padding: 37px 13px 36px 133px;
              box-sizing: border-box;
              line-height: 26px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
          }
        }
        .case-item:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
    // 他的日期
    .hisDate {
      width: 100%;
      border-radius: 45px;
      margin-top: 81px;
      background-image: url(../../assets/details-case.png);
      background-size: 100% 100%;
      padding: 120px 100px 80px;
      box-sizing: border-box;
      .hisDate-title {
        line-height: 1em;
        font-size: 72px;
        color: #00fff0;
        text-align: center;
        margin-bottom: 100px;
      }
    }
    // 立即下单
    .ordernow {
      width: 728px;
      height: 104px;
      background: linear-gradient(
        90deg,
        rgba(29, 175, 170, 0.8) 0%,
        rgba(35, 254, 246, 0.8) 100%
      );
      margin: 61px auto;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #f6f6f6;
      line-height: 104px;
      text-align: center;
    }
    .scroll {
      width: 100%;
      height: 400px;
      background-image: url(../../assets/details-need.png);
      background-size: 100% 100%;
      padding: 0px 40px 10px 40px;
      box-sizing: border-box;
      margin-bottom: 136px;
      box-sizing: border-box;
      min-height: 400px;
      .nd-top {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .nd-top-title {
          width: 333px;
          height: 48px;
          background-size: 100% 100%;
          font-size: 22px;
          font-weight: bold;
          color: #2efeff;
          text-align: center;
          padding-left: 48px;
          line-height: 48px;
          box-sizing: border-box;
        }
      }
      // .scrollBox {
      //   width: 100%;
      //   overflow-x: scroll;
      // }
      // .scrollContent {
      //   white-space: nowrap;
      // }
      .scrollImage {
        height: 300px;
        // height: 100%;
        width: auto;
        user-select: none;
        -webkit-user-drag: none;
        margin-right: 10px;
      }
    }
    .introduce {
      width: 100%;
      background-image: url(../../assets/details-need.png);
      background-size: 100% 100%;
      padding: 0px 40px 10px 40px;

      box-sizing: border-box;
      margin-bottom: 136px;
      box-sizing: border-box;
      min-height: 400px;
      // overflow-y: scroll;

      div {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 500;
        padding: 10px 0;
        color: #e3fffd;
      }

      .nd-top {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .nd-top-title {
          width: 333px;
          height: 48px;
          background-size: 100% 100%;
          font-size: 22px;
          font-weight: bold;
          color: #2efeff;
          text-align: center;
          padding-left: 48px;
          line-height: 48px;
          box-sizing: border-box;
        }
      }
    }
    // 你可能需要
    .need {
      width: 100%;
      background-image: url(../../assets/details-need.png);
      background-size: 100% 100%;
      padding: 40px 0 0;
      box-sizing: border-box;
      margin-bottom: 136px;
      box-sizing: border-box;
      .nd-top {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .nd-top-title {
          width: 333px;
          height: 48px;
          background-size: 100% 100%;
          font-size: 22px;
          font-weight: bold;
          color: #2efeff;
          text-align: center;
          padding-left: 48px;
          line-height: 48px;
          box-sizing: border-box;
        }
      }
      .nd-bottom {
        padding: 50px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .nd-bottom-item {
          margin-right: 53px;
          margin-bottom: 30px;
          .nd-bottom-item-top {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            text-align: right;
            padding-left: 232px;
            padding-right: 4px;
            box-sizing: border-box;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .nd-bottom-item-bottom {
            display: flex;
            align-items: flex-start;
            .nd-bottom-item-bottom-left {
              width: 220px;
              height: 131px;
              background-image: url(../../assets/index-hot-item.png);
              background-size: 100% 100%;
              padding: 15px 20px;
              box-sizing: border-box;
              img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            .nd-bottom-item-bottom-right {
              width: 247px;
              height: 155px;
              background-image: url(../../assets/index-hot-item2.png);
              background-size: 100% 100%;
              margin-left: -56px;
              padding: 28px 0 0 75px;
              box-sizing: border-box;
              .nd-bottom-item-bottom-right-list {
                width: 170px;
                height: 116px;
                background: rgba(31, 73, 135, 0.37);
                border: 1px solid rgba(0, 255, 255, 0.37);
                box-sizing: border-box;
                padding: 23px 0 33px 14px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                .nd-bottom-item-bottom-right-li {
                  color: #ffffff;
                  line-height: 1em;
                  font-size: 14px;
                }
              }
            }
          }
        }
        .nd-bottom-item:nth-child(4n) {
          margin-right: 0px;
        }
      }
    }
  }
  .title {
    margin-top: 50px;
    width: 100%;
    height: 131px;
    background-image: url(../../assets/details-title.png);
    background-size: 100% 100%;
    position: relative;
    span {
      margin: 0 auto;
      width: 1504px;
      height: 87px;
      display: block;
      text-align: center;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #00fcff;
      line-height: 87px;
      padding-right: 70px;
      box-sizing: border-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    img {
      width: 48px;
      height: 42px;
      display: block;
      position: absolute;
      top: 22px;
      right: 200px;
    }
  }
}
</style>
